import { THeaders } from "#/types";

export function headerDecorator(
  headers?: THeaders,
  accessToken?: string
): THeaders {

  let _headers: THeaders = {
    Accept: "application/json",
  }

  if (headers) _headers = { ..._headers, ...headers };

  if (accessToken) _headers.Authorization = `Bearer ${accessToken}`;

  return _headers;
}
